export default __webpack_public_path__ + "landingPageJVRRatee.html";